<div class="modal-content">
    <div class="modal-header justify-content-center">
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
          <i class="nc-icon nc-simple-remove"></i>
      </button>
        
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="card card-plain">
                <div class="card-header" role="tab" id="headingOne">
                    <span data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      Anexe o motivo da inconsistência do movimento.
                  </span>
                  <table class="table"
                  [ngClass]="{
                    'ocult': cD_BPM_MOVIMENTACAO_PATRIMONIAL == 0
                  }">
                    <thead>
                      <tr>
                        <th [ngClass]="{
                          'ocult': dataArray?.dS_AUTOR_EVIDENCIA == undefined
                        }">Autor da Evidencia</th>
                        <th [ngClass]="{
                          'ocult': dataArray?.dS_BPM_TEXTO_EVIDENCIA == undefined
                        }">Descrição da Evidencia</th>
                        <th [ngClass]="{
                          'ocult': dataArray?.cD_BPM_ARQUIVO_PATRIMONIAL == 0
                        }">Nome do Arquivo</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td  [ngClass]="{
                          'ocult': dataArray?.dS_AUTOR_EVIDENCIA == undefined
                        }" >
                        {{ dataArray?.dS_AUTOR_EVIDENCIA }}
                        </td>
                        <td [ngClass]="{
                          'ocult': dataArray?.dS_BPM_TEXTO_EVIDENCIA == undefined
                        }">
                        {{ dataArray?.dS_BPM_TEXTO_EVIDENCIA }}
                        </td>
                        <td type="button" class="text-truncate btn-link"
                        [ngClass]="{
                          'ocult': dataArray?.cD_BPM_ARQUIVO_PATRIMONIAL == 0
                        }" (click)="upload_abrir(dataArray.cD_BPM_ARQUIVO_PATRIMONIAL)">
                        {{ dataArray?.dS_BPM_FILENAME_ARQUIVO_PATRIMONIAL }}
                        </td>
                      </tr>
                      <br/> 
                    </tbody>
                  </table>
                </div>
                <div class="card-body">
                    <form [formGroup]="form">
                        <div class="row justify-content-center">
                            <div class="form-group" [ngClass]="{
                                'ocult': cD_BPM_MOVIMENTACAO_PATRIMONIAL != 0
                              }">
                                <label for="meuBem">Meus Bens</label>
                                
                                    <ng-autocomplete 
                                    id="meuBem"
                                    [data]="cadastro"
                                    [searchKeyword]="keywordMeusBens"
                                    (selected)='selectMeusBens($event)'
                                    [itemTemplate]="itemTemplateMeusBens"
                                    [notFoundTemplate]="notFoundTemplateMeusBens"
                                    value=""
                                    >                                 
                                  </ng-autocomplete>
                                  
                                  <ng-template #itemTemplateMeusBens let-item>
                                  <span [innerHTML]="item.dS_BPM_DESCRICAO_BEM">
                                  </span>
                                 
                                  </ng-template>
                                  
                                  <ng-template #notFoundTemplateMeusBens let-notFound>
                                  <div [innerHTML]="notFound"></div>
                                  </ng-template>
                                
                            
                            </div>
                            <div class="col-md-6 p-3">
                                <input #file 
                                type="file" 
                                enctype="multipart/form-data" 
                                (change)="onChange(file.files)"
                                value="arquivo.cD_BPM_ARQUIVO_PATRIMONIAL">  
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="nome">Descrição da Evidencia</label>
                                    <textarea type="text" class="form-control" placeholder="Descrição da Evidencia"
                                        formControlName="dS_BPM_TEXTO_EVIDENCIA"
                                        [ngClass]="{
                                            'has-danger':
                                              form.controls.dS_BPM_TEXTO_EVIDENCIA.errors?.required &&
                                              form.controls.dS_BPM_TEXTO_EVIDENCIA.touched
                                          }"required></textarea>
                                </div>
                            </div>
                            <div>
                                <tbody>
                                    <tr>
                                        <td *ngFor="let file of arquivos">
                                            <strong>{{ file.dS_BPM_FILENAME_ARQUIVO_PATRIMONIAL }}</strong>
                                        </td>
                                    </tr>
                                    
                                </tbody>
                                
                            </div>
                            <div class="progress mw-100">
                                <div class="progress-bar bg-success" 
                                role="progressbar"  
                                aria-valuenow="25" 
                                aria-valuemin="0" 
                                aria-valuemax="100"
                                [style.width]="progress + '%'">
                                {{  progress  }}
                              </div>
                            </div>

                        </div>
                    </form>
                    <div class="row">
                        <div class="col-md-12 text-center" *ngIf="loading">
                            <img src="./assets/img/loading.png" class="loading" id="loadingImage" height="50" width="50" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!loading" class="modal-footer">
        <div class="left-side">
            <button 
            type="button" 
            class="btn btn-success btn-link" 
            (click)="confirmar()" [disabled]="!form.valid">
            <i class="fa fa-thumbs-up"></i> Confirmar
          </button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
            <button 
            type="button" 
            class="btn btn-danger btn-link"
            (click)="cancelar()">
             Fechar a inconsistência
          </button>
        </div>
    </div>
</div>
